import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";

import { UserMe } from "@serasa/core/modules/recertification/interfaces/user-me.interface";
import { Observable } from "rxjs";
import { SidenavManagerService } from "../../../../../shared/services/sidenav.manager.service";
import { Utils } from "../../../../../shared/utils/utils";
import { UserService } from "../../services/user.service";
import * as UserActions from "../../state/actions/user.actions";
import { closeSideNav } from "../../state/actions/user.actions";
import { selectLogon, selectUserMeInfo } from "../../state/selectors/user.selectors";

@Component({
    selector: "pl-user-edit-confirmation",
    templateUrl: "./user-edit-confirmation.component.html",
    styleUrls: ["./user-edit-confirmation.component.scss"],
    standalone: false
})
export class UserEditConfirmationComponent implements OnInit {
  public notificationsOptions = {
    status: "success",
    title: "Usuário editado com sucesso!",
    message: "",
  };

  public showResetButton = false;
  details$ = this.store.select(selectLogon);

  public userMeInfo$!: Observable<UserMe | null | undefined>;

  constructor(
    public sidenavManagerService: SidenavManagerService,
    private readonly _userService: UserService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.sidenavManagerService.resetPasswordFlow$.subscribe(
      (isTrue) => (this.showResetButton = isTrue),
    );
    this.userMeInfo$ = this.store.select(selectUserMeInfo)
  }

  public closeSideNav() {
    this._userService.updated$.next(true);
    this.store.dispatch(closeSideNav());
    this.store.dispatch(UserActions.loadUserMeInfo());
  }

  public canUserSeeUnblockedOption(user: any): boolean {
    return Utils.canUserSeeUnblockedOption(user);
  }
}
